export const PAGINATION_PAGESIZE_OPTIONS = [
  25, 50, 100, 200, 'All'
];

export const MAX_PAGE_SIZE = 9999999;
export const MIN_ASYNC_PAGE_SIZE = 500;
export const MAX_ASYNC_REQUEST_COUNT = 5;
